import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import Group from '../../../../../components/form/elements/group';
import Text from '../../../../../components/form/elements/text';
import TextArea from '../../../../../components/form/elements/text-area';
import * as yup from 'yup';
import { date, dealType, makeButton } from '../form-parts';
import { useWarehouseContext } from '../warehouse-context';
import CreateMovedTable from './moved-table';
import Hidden from '../../../../../components/form/elements/hidden';
import { useParams } from 'react-router';
import { useService } from '../../../../../services/services';
import css from './moved.module.css';
import { DirectSendIcon } from '../../../../../assets/icons';

export function useMovedForm(formMethods, mode) {
  const { t } = useTranslation();
  const { farmId, id } = useParams<{ farmId: string; id?: string }>();
  const { dealService } = useService();
  const { setIsOpen } = useWarehouseContext();

  const handleClick = () => {
    setIsOpen(true);
  };

  const [form] = useState(() => [
    Group(
      [
        Group(
          [
            dealType(t, true),
            date(true),
            Text(
              'purchase_document_number',
              'pages.warehouse.deals.purchase_document_number',
              null,
              null,
              true
            ),
            mode !== 'view'
              ? () => null
              : makeButton(
                  'pages.warehouse.deals.create_accompanying_document',
                  'white-button',
                  'grow-4 text-end',
                  null,
                  true,
                  () => {
                    dealService
                      .movedDealInvoiceExportXls(farmId, id)
                      .subscribe();
                  },
                  DirectSendIcon
                ),
          ],
          null,
          false,
          false,
          true,
          `${css['form_body_top_group_top']} ${
            mode !== 'view'
              ? css['create_invoice_without_box']
              : css['create_invoice_with_box']
          }`
        ),
      ],
      null,
      false,
      false,
      false,
      css['form_body_top']
    ),
    Hidden('products_exists'),
    Group([
      mode === 'view'
        ? () => null
        : makeButton(
            'pages.warehouse.products.add-product',
            'pink-button',
            '',
            faPlus,
            false,
            handleClick
          ),
    ]),
    Group([() => CreateMovedTable(mode)]),
    Group([
      TextArea('comment', 'pages.warehouse.deals.notes', 2, true, 'full-width'),
    ]),
  ]);

  return form;
}

export const movedSchema = (isRequired: boolean = false) => {
  return yup.object().shape({
    type: yup.object().shape({
      value: yup.string().required(),
    }),
    date: yup.date().required(),
    products_exists: yup.bool().required(),
  });
};
